module.exports = __webpack_public_path__ + "img/bg.a0e6734.jpg";